import { Component, Input } from '@angular/core';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { BankModel, ContractModel, ContractRequest, HxSupplierService, OrganizationModel } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ErrorHandlerService } from '@manager-app/service/error-handler.service';
import { NgFor, NgIf } from '@angular/common';
import { OrganizationSelectComponent } from '../../components/organization-select/organization-select.component';
import { FormsModule } from '@angular/forms';
import { HxDateSelectComponent } from 'hx-component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-suppliers-contract',
    templateUrl: './suppliers-contract.component.html',
    styleUrls: ['./suppliers-contract.component.css'],
    imports: [NgIf, NgFor, OrganizationSelectComponent, FormsModule, HxDateSelectComponent, NgbTooltip, TranslocoPipe]
})
export class SuppliersContractComponent {
  list: ContractModel[] = [];
  isLoading = {
    list: false,
  };
  @Input() countryId?: number;
  private _id: number;
  @Input()
  set id(val) {
    this._id = val || null;
    if (val) {
      this.getList();
    }
  }

  get id() {
    return this._id;
  }

  constructor(
    private supplierService: HxSupplierService,
    private toastr: HcToastrService,
    private errorHandlerService: ErrorHandlerService,
    private tr: TranslocoService
  ) {
  }

  addItem() {
    this.list.push({
      id: null,
      number: null,
      date: null,
      title: null,
      note: null,
      organization: {} as OrganizationModel,
      supplier: null,
      files: [],
      currency: null,
      dueDays: null,
      bank: {} as BankModel,
      iban: null
    });
  }

  addField() {
    this.addItem();
  }

  updateData(item: ContractModel) {
    if (this.id) {
      const request = {} as ContractRequest;
      request.number = item.number;
      request.date = item.date;
      request.title = item.title;
      request.note = item.note;
      request.supplierId = this.id;
      request.organizationId = item.organization?.id;
      request.bankId = item.bank?.id;
      request.iban = item.iban;

      let api = this.supplierService.createSupplierContract(this.id, request);

      if (item && item.id) {
        api = this.supplierService.updateSupplierContract(this.id, item.id, request);
      }

      api.subscribe(() => {
          if (item && item.id) {
            this.toastr.success(this.tr.translate('suppliers-contact.ts.upSuccess'));
          } else {
            this.toastr.success(this.tr.translate('suppliers-contact.ts.saveSuccess'));
          }
          this.getList();
        }, err => this.errorHandlerService.check(err.error)
      );
    }
  }

  removeField(item, index) {
    if (item && item.id) {
      this.deleteItem(item.id);
    } else {
      this.list.splice(index, 1);
    }
  }

  private deleteItem(id) {
    if (id) {
      this.supplierService.removeSupplierContract(this.id, id).subscribe(() => {
        this.toastr.success(this.tr.translate('suppliers-contact.ts.deleteSuccess'));
        this.getList();
      });
    }
  }

  private getList() {
    this.list = [];
    this.isLoading.list = true;

    this.supplierService.getSupplierContractList(this.id).subscribe(
      result => {
        this.list = result || [];
        this.isLoading.list = false;
      },
      () => {
        this.isLoading.list = false;
      }
    );
  }
}
